import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Link, { linkBase } from '@src/mobile/components/Link';
import { isIOS } from '@src/public/utils';
import { isGrounds, openAppShare } from '@src/public/utils/app';
import { formatPeopleCount } from '@src/public/utils/format';
import styles from './index.css';
import { getCommonList } from '../service';
import { ListStore } from '../store';
import Danmu from '../Danmu';

const cx = classNames.bind(styles);

const Bottom = () => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { id, title, allowComment, summary, shareImgUrl, interactionRsp, showDanmu } = listStates;
    // 弹幕功能区域
    const [showDanmuState, setShowDanmuState] = useState(true);
    // 弹幕切换
    const [showDanmuTitle, setShowDanmuTitle] = useState(true);
    // 弹幕数量
    const [danmu, setDanmu] = useState();

    const danmuRef = useRef();

    const handleShareImgClick = () => {
        changeListStates({ showShareLongImg: true });
    };

    // 弹幕文字开关
    const handleDanmuClick = () => {
        setShowDanmuTitle(!showDanmuTitle);
        danmuRef.current.hangleToggle();
    };

    const handleShareClick = () => {
        const shareTitle = title;
        const desc = summary;
        const url = `${window.location.origin.replace('timeline', 'ishare')}${window.location.pathname}${
            window.location.search
        }`;

        openAppShare({ title: shareTitle, desc, thumbnail: shareImgUrl, url });
    };

    // 美伊战争页面
    const isWarPage = id === '8r727OWpK5W';

    // 监听弹幕数量显示弹幕开关
    useEffect(
        () => {
            if (showDanmu) {
                getCommonList({ id, size: 50, isWarPage }).then(res => {
                    if (res.length < 10) {
                        setShowDanmuState(false);

                        return;
                    }

                    setDanmu(res);
                });
            }
        },
        [showDanmu],
    );

    const formatInteractionRspComment = count => {
        if (count) {
            return formatPeopleCount(count);
        } else {
            return '抢沙发';
        }
    };

    return (
        <>
            {showDanmu && danmu ? (
                <Danmu id={id} ref={danmuRef} isBrand={!isGrounds ? true : ''} danmu={danmu} />
            ) : null}
            <div className={styles.placeholder} />
            <div className={styles.wrap} style={{ display: `${!(showDanmu && showDanmuState) && isWarPage && !isGrounds ? 'none' : 'block' }` }}>
                <div className={styles.content}>
                    {/* <div className={styles.spill}>
                        <Link
                        to={`${linkBase}/loc/timeline/spill/${id}`}
                        className={styles.spillLink}
                        >
                        我要加料
                        </Link>
                    </div> */}
                    <div className={styles.btnGroup}>
                        {showDanmu && showDanmuState ? (
                            <div className={styles.btn} onClick={handleDanmuClick}>
                                <div className={cx('btnIcon', 'iconDanmu')} />
                                <div className={styles.btnText}>{showDanmuTitle ? '弹幕开' : '弹幕关'}</div>
                            </div>
                        ) : null}
                        {isWarPage ?
                            null :
                            <div className={cx('btn', { btnNotAllowComment: !allowComment })}>
                                {allowComment ? (
                                    <Link to={`${linkBase}/loc/timeline/comment/${id}`}>
                                        <div className={cx('btnIcon', 'iconComment')}>
                                            {interactionRsp ? (
                                                <div className={styles.commentNum}>
                                                    {formatInteractionRspComment(interactionRsp.comment)}
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className={styles.btnText}>评论</div>
                                    </Link>
                                ) : (
                                    <>
                                        <div className={cx('btnIcon', 'iconComment')} />
                                        <div className={styles.btnText}>评论</div>
                                    </>
                                )}
                            </div>}

                        {/* {isGrounds && !isIOS() ? ( */}
                        {/*     <div className={styles.btn} onClick={handleShareImgClick}> */}
                        {/*         <div className={cx('btnIcon', 'iconShareImg')} /> */}
                        {/*         <div className={styles.btnText}>分享长图</div> */}
                        {/*     </div> */}
                        {/* ) : null} */}
                        {isGrounds ? (
                            <div className={styles.btn} onClick={handleShareImgClick}>
                                <div className={cx('btnIcon', 'iconShareImg')} />
                                <div className={styles.btnText}>分享长图</div>
                            </div>
                        ) : null}

                        {isGrounds ? (
                            <div className={styles.btn} onClick={handleShareClick}>
                                <div className={cx('btnIcon', 'iconShare')} />
                                <div className={styles.btnText}>转发</div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
};

export default errorBoundary(Bottom);
